import ScoringRequestTableView from './scoringRequestTableView';

export default ScoringRequestTableView;
